import { Button, CircularProgress, Grid } from '@material-ui/core'
import useStyles from './styles'
import { FC, ReactNode } from 'react'

import { icons } from 'assets'

interface Button {
  title: string
  action?: () => void
  disable?: boolean
  icon?: ReactNode
  loading?: boolean
}

export interface BottomButtonsProps {
  buttonNext: Button
  buttonBack?: Button
  showNextButton?: boolean
}

const BottomButtons: FC<BottomButtonsProps> = ({
  buttonBack,
  buttonNext,
  showNextButton = true,
}) => {
  const classes = useStyles()

  return (
    <Grid
      item
      container
      xs={12}
      style={{ display: 'flex' }}
      justifyContent="space-between"
    >
      <Button
        type="submit"
        variant="contained"
        size="small"
        className={classes.buttonBack}
        startIcon={buttonBack?.icon || <icons.ArrowBack />}
        onClick={buttonBack?.action || (() => {})}
        disabled={buttonBack?.disable || buttonBack?.loading}
      >
        {buttonBack?.loading ? <CircularProgress /> : buttonBack?.title}
      </Button>
      {showNextButton && (
        <Button
          type="submit"
          variant="contained"
          size="small"
          className={classes.buttonNext}
          endIcon={buttonNext?.icon || <icons.ArrowForward />}
          onClick={buttonNext?.action || (() => {})}
          disabled={buttonNext?.disable || buttonNext?.loading}
        >
          {buttonNext?.loading ? <CircularProgress /> : buttonNext?.title}
        </Button>
      )}
    </Grid>
  )
}

export default BottomButtons
